import {AttachMoney} from '@mui/icons-material'
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const getDeposit = () => ({
    id: 'deposit',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'deposit',
            title: i18n.t('sidemenu.depositManagement'),
            type: 'item',
            url: '/deposit',
            icon: AttachMoney,
            breadcrumbs: false
        },
       
    ]
});

export default getDeposit;

